module.exports = __webpack_public_path__ + "img/rocket-anim.fbc93a8b.webp";